<template>

<div>

    <div class="jumbotron page-header d-flex justify-content-center align-items-center">
        <div class="inner-page-header text-center pb-5">
            <span class="icon icon-startup"></span>
            <h1>Създаване на проект</h1>
            <div class="breadcrumbs">
                <breadcrumbs></breadcrumbs>
            </div>
        </div>
    </div>

    <div class="main-page-content">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="page-header-info shadow-lg p-4 mb-lg-5 text-center">
                        Тук можеш да въведеш параметрите на твоя обект и да ни го изпратиш.
                        Ние ще ти помогнем да намериш изпълнители за всяка една фаза от неговото развитие и изработка.
                        Ще организираме търгове и конкурси, с помощта на които да намериш най-изгодните за теб оферти.
                    </div>
                </div>

            </div>

            <div class="accordion mb-5" id="accordionNewProject">
               <div class="accordion-item">
                    <div class="accordion-header" id="heading-1">
                        <h5 class="accordion-title mb-0 d-flex justify-content-between align-items-center collapsed" data-toggle="collapse" data-target="#collapse-1" aria-expanded="false" aria-controls="collapse-1">
                          Насоки за създаване на проект
                          <span class="icon icon-plus-circle"></span>
                          <span class="icon icon-minus-circle"></span>
                        </h5>
                    </div>

                    <div id="collapse-1" class="collapse" aria-labelledby="heading-1" data-parent="#accordionNewProject">
                      <div class="accordion-body">
                            <h6 class="mb-2">Формулиране на Задание за проектиране във фаза Конкурс за Идеен проект</h6>
                            <p>
                                Огромно значение за крайния резултат на проекта има добре оформеното
                                (подробно, пълно) разписано задание за проектиране. То може да се допълва,
                                конкретизира, променя на следващите фази – технически и работен проект. За
                                улеснение на Възложителя се предоставят насоки за изготвяне на задание за
                                проектиране.
                            </p>

                            <h6 class="mb-2">Насоки и указания за изготвяне на Задание за проектиране</h6>
                            <p class="mb-0">
                                Този документ се оформя като свободен текст - обяснителна записка. Представлява свободно описание на предвидените функции, процеси, обитатели, ползватели.
                            </p>
                            <ol>
                                <li>Формулират се необходимите намеси и преустройства.</li>
                                <li>Дават се пояснения за предпочитани цветове, материали, естествена и изкуствена светлина, търсена емоция, настроение, форми и обеми, стил.</li>
                                <li>Дава се информация за година на построяване на обекта, носеща конструкция и преградни стени, дограма, географско изложение.</li>
                                <li>Описват се съществуващите и планираните инсталации и оборудване.</li>
                                <li>Предоставя се информация за текущото състояние на обекта. Дали обектът е на груб строеж или е на шпакловка и замазка. Дали се обитава и какво се запазва - например настилки, врати, част от мебелите. Дали ще се променя предназначението, конфигурацията на преградните стени, инсталациите.</li>                         
                                <li>
                                    Определя се предпочитан стил – класически или съвременен. Популярните стилове
                                    в интериора са: Съвременен, Модернизъм, Минималистичен, Индустриален,
                                    Скандинавски, Винтидж, Поп арт, Шаби шик, Бохо шик, Провинциален, Рустикален,
                                    Средиземноморски, Колониален, Тропически, Азиатски, Еклектичен, Класически, Арт
                                    Деко, Модерн, Сецесион и т.н.
                                </li>
                            </ol>

                            <p class="mt-3 mb-0">
                                Целта на VIDEA е да се реализират интериори, които в най-голяма степен изразяват
                                вкусовете и светоусещането на възложителя. Важно е да се определи кои са
                                предпочитаните стилове, цветове, материали, функционалност, елементи на
                                обзавеждането и атмосфера. Затова е необходимо като част от заданието да се
                                предоставят набор от характерни положителни и отрицателни примери и отпратки.
                                Важно е да се направи уточнение, че всяко пространство има свой собствени
                                отличителни черти и специфични характеристики и затова към него е необходим
                                индивидуален подход, при който референтните примери не могат да бъдат приложени
                                автоматично.
                            </p>                            
                      </div>
                    </div>
                </div>
            </div>

            <project-form></project-form>

        </div>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {
           this.setBcLinks([ { name : 'Създаване на нов проект', url : 'add-project' } ]);
        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
            }
        },

        methods : {

            //Callback for successfull creation
            onSaveSuccess( id ) {

                setTimeout( () => {

                    location.href = '/my-projects/' + id;

                }, 750 );

            }

        }

    }
</script>
